import { useGetLosByQConfigStructureLazyQuery } from '@exam-management/graphql';
import type { OptionSelectionProps } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

interface UseFetchLosProps {
  qConfigId: string;
  qConfigStructureId: string;
  contentType: 'LOS' | 'TOPIC';
}

export default function useFetchLos(props: Readonly<UseFetchLosProps>) {
  const { qConfigId, qConfigStructureId, contentType } = props;

  const [options, setOptions] = useState<OptionSelectionProps[]>([]);

  const [getLOS, { data: losResult, loading: isSearchLOSLoading }] =
    useGetLosByQConfigStructureLazyQuery({
      fetchPolicy: 'network-only',
    });

  const fetchLOS = useCallback(async () => {
    await getLOS({
      variables: {
        input: {
          qConfigId,
          qConfigStructureId,
        },
      },
    });
  }, [qConfigId, qConfigStructureId, getLOS]);

  useEffect(() => {
    const losOptions = (losResult?.excGetQConfigChapter.learningObjectiveStatements ?? [])
      .map((los) => ({
        label: los.tag.name,
        value: los.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    setOptions(losOptions);
  }, [losResult]);

  useEffect(() => {
    if (contentType === 'LOS' && qConfigStructureId) {
      fetchLOS();
    }
  }, [contentType]);

  return {
    options,
    isSearchLOSLoading,
  };
}
